import { render, staticRenderFns } from "./Shitang1.vue?vue&type=template&id=7c1978d7&scoped=true"
import script from "./Shitang1.vue?vue&type=script&lang=js"
export * from "./Shitang1.vue?vue&type=script&lang=js"
import style0 from "./Shitang1.vue?vue&type=style&index=0&id=7c1978d7&prod&scoped=cabteeb&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1978d7",
  null
  
)

export default component.exports